import { z } from 'zod/v4';

export const ListUserCompaniesParamsSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
});

export type ListUserCompaniesParams = z.infer<
  typeof ListUserCompaniesParamsSchema
>;

export const UserCompanyListRowSchema = z.looseObject({
  id: z.string(),
  companyId: z.string(),
  userId: z.string(),
  isPrimary: z.boolean(),
  hasAgreedWithTerms: z.boolean(),
  hasAgreedWithTermsAt: z.string().nullable(),
  name: z.string().nullable(),
  officialName: z.string().nullable(),
  facilityProcesses: z.string().nullable(),
  isActiveCompany: z.number(),
});

export type UserCompanyListRow = z.infer<typeof UserCompanyListRowSchema>;

// Envelope matches the legacy `reply.paginate()` shape so the FE keeps
// reading `response.data.data` / `response.data.meta` unchanged.
export const ListUserCompaniesResponseSchema = z.object({
  data: z.array(UserCompanyListRowSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type ListUserCompaniesResponse = z.infer<
  typeof ListUserCompaniesResponseSchema
>;
